module.exports = __webpack_public_path__ + "img/4383a3e.svg";